import styled from 'styled-components';

import { StyleColor } from '../../../utils/styles-constants';

const Wrapper = styled('div')`
	display: flex;
	justify-content: center;

	label {
		box-sizing: border-box;
		position: relative;
		padding-left: 30px;
		font-size: 14px;
		line-height: 20px;
		color: ${StyleColor.Grey500};
		cursor: pointer;

		&::before {
			content: '';
			box-sizing: inherit;
			position: absolute;
			top: 0;
			left: 0;
			width: 20px;
			height: 20px;
			border: 2px solid currentColor;
			border-radius: 4px;
		}

		input {
			display: none;
		}

		svg {
			position: absolute;
			top: 3px;
			left: 3px;
			width: 14px;
			height: 14px;
			fill: currentColor;
		}
	}
`;

export {
	Wrapper,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/Checkbox/styles.ts